const menuDrawer = document.getElementById("t4s-menu-drawer");


 const logo = document.querySelector(".t4s-header__logo");
 const menu = document.querySelector(".t4s-container .t4s-row .t4s-col-md-4")

 
  function actualizarEstilo() {
    const ariaHiddenValue = menuDrawer.getAttribute("aria-hidden");
    
  
    if (ariaHiddenValue == "false") {
      logo.style.display = "none";
      menu.style.display = "none";
      
    } else {
      logo.style.display = "block";
      menu.style.display = "flex";
      
    }
  }


  actualizarEstilo();

  const observer = new MutationObserver(actualizarEstilo);
  observer.observe(menuDrawer, { attributes: true }); 